import styled from 'styled-components';

export const Overlay = styled.section`
  position: fixed;
  left: 0;
  top: 0;
  z-index: 8;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(32, 32, 32, 0.99);
  width: 100%;
  height: 100%;
`;

export const Div = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin: 40px 0;
  z-index: 2;
`;
